import config from 'constants/config'
import { createSelector } from 'reselect'

export const getPeopleLikeMeEntryExperimentVariant = createSelector(
  (state: App.State) => state.config.experiments[config.AB_TEST_PEOPLE_LIKE_ME_ENTRY],
  (variant) => variant,
)

export const getPropertySearchToOfferPageExperimentVariant = createSelector(
  (state: App.State) => state.config.experiments[config.AB_TEST_PROPERTY_SEARCH_TO_OFFER_PAGE],
  (variant) => variant === '1',
)

export const getHotelTrendingDestinationsPercentileExperiment = createSelector(
  (state: App.State) => state.config.experiments[config.AB_TEST_TRENDING_DESTINATIONS_BY_PERCENTILE],
  (variant) => variant === '1',
)

export const getShowOnMapOfferExperimentVariant = createSelector(
  (state: App.State) => state.config.experiments[config.AB_TEST_SHOW_ON_MAP],
  (variant) => variant === '1',
)

export const getUrgencyBannerExperimentVariant = createSelector(
  (state: App.State) => state.config.experiments[config.AB_TEST_SEARCH_URGENCY_BANNER],
  (variant) => variant,
)
